[
    {
        "lista": "OFAC",
        "estatus": 4
    },
    {
        "lista": "OFACN",
        "estatus": 4
    },
    {
        "lista": "ONU",
        "estatus": 4
    },
    {
        "lista": "SAT69B",
        "estatus": 4
    },
    {
        "lista": "CAR",
        "estatus": 4
    },
    {
        "lista": "DPRK",
        "estatus": 4
    },
    {
        "lista": "DRC",
        "estatus": 4
    },
    {
        "lista": "IRAN",
        "estatus": 4
    },
    {
        "lista": "IRAQ",
        "estatus": 4
    },
    {
        "lista": "PPE",
        "estatus": 4
    },
    {
        "lista": "PEPINT",
        "estatus": 4
    },
    {
        "lista": "SAT69",
        "estatus": 2
    },
    {
        "lista": "SANC",
        "estatus": 4
    },
    {
        "lista": "ATF",
        "estatus": 4
    },
    {
        "lista": "BID",
        "estatus": 4
    },
    {
        "lista": "BIS",
        "estatus": 4
    },
    {
        "lista": "BM",
        "estatus": 4
    },
    {
        "lista": "BOE",
        "estatus": 4
    },
    {
        "lista": "CBI",
        "estatus": 4
    },
    {
        "lista": "DEA",
        "estatus": 4
    },
    {
        "lista": "DFAT",
        "estatus": 4
    },
    {
        "lista": "EPA",
        "estatus": 4
    },
    {
        "lista": "FAMI",
        "estatus": 4
    },
    {
        "lista": "FBI",
        "estatus": 4
    },
    {
        "lista": "FINCEN",
        "estatus": 4
    },
    {
        "lista": "FUNC",
        "estatus": 4
    },
    {
        "lista": "GAFI",
        "estatus": 4
    },
    {
        "lista": "HMT",
        "estatus": 4
    },
    {
        "lista": "ICE",
        "estatus": 4
    },
    {
        "lista": "INTP",
        "estatus": 4
    },
    {
        "lista": "LMW",
        "estatus": 4
    },
    {
        "lista": "OCDE",
        "estatus": 4
    },
    {
        "lista": "OSFI",
        "estatus": 4
    },
    {
        "lista": "FGJ",
        "estatus": 4
    },
    {
        "lista": "FGR",
        "estatus": 4
    },
    {
        "lista": "FGRCOM",
        "estatus": 4
    },
    {
        "lista": "PIS",
        "estatus": 4
    },
    {
        "lista": "REFIPRE",
        "estatus": 4
    },
    {
        "lista": "SSEU",
        "estatus": 4
    },
    {
        "lista": "UE",
        "estatus": 4
    },
    {
        "lista": "UKMW",
        "estatus": 4
    },
    {
        "lista": "USMS",
        "estatus": 4
    },
    {
        "lista": "VENC",
        "estatus": 4
    },
    {
        "lista": "GB",
        "estatus": 4
    }
]
